import './custom-scrollbar';

// Entsorgungswege und Bringdienst werden vom Provider mit dem Standard-Theme ausgeliefert, das
// iframe.css nicht per @import einbindet (die uebrigen Module nutzen themeFuerAgentur_*.css).
// Fehlt das CSS, haengen wir es hier an: gleicher Ordner wie dieses Skript. Bis es geladen ist,
// bleibt die Seite unsichtbar, damit der unformatierte Zustand nicht aufblitzt.
(() => {
  const isHauptseitenModul = () => document.querySelector('#Entsorgungswege_container, #BringdienstView_container');
  const cssActive = () => getComputedStyle(document.documentElement).getPropertyValue('--iframe-container-width').trim() !== '';
  const ensureStylesheet = () => {
    if (!isHauptseitenModul() || cssActive()) {
      return;
    }
    const script = document.currentScript || document.querySelector('script[src*="iframe.js"]');
    if (!script || !script.src) {
      return;
    }
    const hide = document.createElement('style');
    hide.textContent = 'html { visibility: hidden; }';
    document.head.appendChild(hide);
    const reveal = () => {
      hide.remove();
      window.dispatchEvent(new Event('resize'));
    };
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = script.src.replace(/iframe\.js(\?.*)?$/, 'iframe.css$1');
    link.addEventListener('load', reveal);
    link.addEventListener('error', reveal);
    document.head.appendChild(link);
    window.setTimeout(reveal, 3000);
  };
  ensureStylesheet();
})();

// Bringdienst: Der Provider blendet Termine ausserhalb von Zeitraum/Umkreis per display:none aus.
// "Naechster Termin" ist deshalb der erste SICHTBARE Eintrag; das kann CSS allein nicht erkennen.
(() => {
  const list = document.getElementById('ListeBlock');
  if (!list || !document.getElementById('BringdienstView_container')) {
    return;
  }

  // Fokusreihenfolge = sichtbare Reihenfolge: Der Zeitraum steht im Layout unter den
  // Adressfeldern, im Provider-HTML aber davor. Die Bloecke werden ueber ihre IDs
  // angesprochen, ihre Position im DOM ist dafuer frei.
  const zeitraum = document.getElementById('ZeitraumBlock');
  const standort = document.getElementById('StandortBlock');
  if (zeitraum && standort && standort.nextElementSibling !== zeitraum) {
    standort.insertAdjacentElement('afterend', zeitraum);
  }
  let queued = false;
  const markNext = () => {
    queued = false;
    let found = false;
    list.querySelectorAll('.bt_eintrag').forEach(entry => {
      const isNext = !found && entry.offsetParent !== null;
      if (isNext) {
        found = true;
      }
      entry.classList.toggle('bt-next', isNext);
    });
  };
  const schedule = () => {
    if (queued) {
      return;
    }
    queued = true;
    window.requestAnimationFrame(markNext);
  };

  // Nur style-Aenderungen beobachten: Das Setzen der Klasse loest den Observer nicht erneut aus.
  new MutationObserver(schedule).observe(list, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style']
  });
  schedule();
})();
(() => {
  // Prevent internal iframe scrolling – the parent page handles all scrolling.
  // This stops the provider's ScrollToPosition() and onPageLoad2() from causing
  // scroll jumps after ONPAGE AJAX calls.
  window.scrollTo = () => {};
  window.scroll = () => {};
  window.scrollBy = () => {};

  // Ensure element.focus() never triggers scroll within the iframe.
  // The provider's focusOnActiveElement() calls .focus() without preventScroll,
  // which causes the viewport to jump after ONPAGE AJAX.
  const originalFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function focusNoScroll(options) {
    originalFocus.call(this, {
      ...options,
      preventScroll: true
    });
  };
  let layoutObserver = null;
  let layoutObserveTarget = null;

  // Ohne Anmeldung liefert das Portal ein leeres <ul id="menuItemsLIST">. Die gestylte
  // Nav-Box wuerde sonst als leere Huelle stehenbleiben und die Sidebar-Spalte belegen.
  const updateSidebarVisibility = () => {
    const navWrapper = document.getElementById('navWrapper');
    if (navWrapper) {
      const menuList = document.getElementById('menuItemsLIST');
      navWrapper.hidden = !(menuList && menuList.querySelector('li'));
    }
    const sidebar = document.getElementById('sidebar');
    const content = document.getElementById('content');
    if (sidebar && content) {
      const hasVisibleChild = Array.from(sidebar.children).some(child => !child.hidden);
      content.classList.toggle('has-no-sidebar', !hasVisibleChild);
    }
  };
  const ensureLayout = () => {
    const navWrapper = document.getElementById('navWrapper');
    const content = document.getElementById('content');
    const loginarea = document.getElementById('loginarea');
    let sidebar = document.getElementById('sidebar');
    if (!sidebar && content) {
      sidebar = document.createElement('div');
      sidebar.id = 'sidebar';
      content.appendChild(sidebar);
    }
    if (sidebar) {
      if (loginarea && loginarea.parentElement !== sidebar) {
        sidebar.appendChild(loginarea);
      }
      if (navWrapper && navWrapper.parentElement !== sidebar) {
        sidebar.appendChild(navWrapper);
      }
    }
    const informations = document.getElementById('Informations');
    const dialogContainer = document.querySelector('.dialog_container');
    if (informations && dialogContainer && informations.parentElement !== dialogContainer) {
      dialogContainer.insertBefore(informations, dialogContainer.firstChild);
    }
    document.querySelectorAll('th[class$="Status"]').forEach(th => {
      const p = th.querySelector('p');
      if (p && !p.textContent.trim()) {
        p.textContent = 'Status';
      }
    });
    const menuList = document.getElementById('menuItemsLIST');
    if (menuList) {
      const navOrder = ['menulistitem_changeWasteContainer', 'menulistitem_behDefekt', 'menulistitem_behverlust', 'menulistitem_disposalOnCall', 'menulistitem_wasteDisposalServices', 'menulistitem_binClearances', 'menulistitem_listFeeNotifications', 'menulistitem_editBankAccount', 'menulistitem_registerWasteDisposal', 'menulistitem_deregisterWasteDisposal', 'menulistitem_pwpErstvergabe', 'menulistitem_passwordForgotten', 'menulistitem_kontoverwaltung'];
      const navHidden = [];
      navHidden.forEach(id => {
        const li = document.getElementById(id);
        if (li) li.style.display = 'none';
      });
      navOrder.forEach(id => {
        const li = document.getElementById(id);
        if (li && li.parentElement === menuList) {
          menuList.appendChild(li);
        }
      });
    }
    const navUrlMap = {
      menulistitem_changeWasteContainer: '/behaelterbestand',
      menulistitem_behDefekt: '/defekter-behaelter',
      menulistitem_behverlust: '/behaelter-verschwunden',
      menulistitem_disposalOnCall: '/sperrmuell-anmelden',
      menulistitem_wasteDisposalServices: '/abfuhrtermine',
      menulistitem_binClearances: '/behaelterleerungen-anzeigen',
      menulistitem_listFeeNotifications: '/online-gebuehrenbescheid',
      menulistitem_editBankAccount: '/einzugsermaechtigung',
      menulistitem_registerWasteDisposal: '/anmeldung-abfallentsorgung',
      menulistitem_deregisterWasteDisposal: '/abmeldung-abfallentsorgung',
      menulistitem_pwpErstvergabe: '/passwortvergabe-privathaushalte',
      menulistitem_passwordForgotten: '/passwort-vergessen',
      menulistitem_kontoverwaltung: '/kontaktdaten-aendern',
      menulistitem_editAddressData: '/kontaktdaten-aendern',
      menulistitem_changeDebitorAccessCode: '/passwort-aendern',
      menulistitem_antragbescheid: '/online-gebuehrenbescheid-an-abmelden'
    };
    document.querySelectorAll('.menulist > li').forEach(li => {
      const hasSubUl = li.querySelector('ul');
      if (hasSubUl) {
        li.classList.add('has-submenu', 'submenu-open');
      } else {
        const id = li.id || '';
        if (id === 'menulistitem_kontoverwaltung') {
          li.classList.add('has-submenu');
        }
      }
    });
    document.querySelectorAll('.menulist a').forEach(link => {
      const li = link.closest('li');
      if (!li) return;
      const url = navUrlMap[li.id];
      if (url && !link.dataset.avlNavBound) {
        link.setAttribute('data-avl-nav-bound', '1');
        link.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          const targetWindow = window.top && window.top !== window ? window.top : window.parent;
          if (targetWindow && typeof targetWindow.postMessage === 'function') {
            targetWindow.postMessage({
              type: 'avlKundenportal:navigate',
              url
            }, '*');
          }
        }, true);
      }
    });
    document.querySelectorAll('td[class$="Status"]').forEach(td => {
      const row = td.closest('tr');
      if (!row) return;
      const text = td.textContent.trim();
      if (text) {
        row.classList.add('row-disabled');
        row.querySelectorAll('input, select, textarea, button').forEach(el => {
          el.setAttribute('disabled', '');
        });
      }
    });
    updateSidebarVisibility();
  };
  let schedulePostHeightFn = null;
  const needsLayoutFix = () => {
    const sidebar = document.getElementById('sidebar');
    const navWrapper = document.getElementById('navWrapper');
    const loginarea = document.getElementById('loginarea');
    if (!sidebar) return true;
    if (navWrapper && navWrapper.parentElement !== sidebar) return true;
    if (loginarea && loginarea.parentElement !== sidebar) return true;
    return false;
  };
  const runEnsureLayout = () => {
    if (layoutObserver) {
      layoutObserver.disconnect();
    }
    ensureLayout();
    if (layoutObserver && layoutObserveTarget) {
      layoutObserver.observe(layoutObserveTarget, {
        childList: true,
        subtree: true
      });
    }
    if (schedulePostHeightFn) {
      schedulePostHeightFn();
    }
  };
  runEnsureLayout();

  // Nach einem ONPAGE-Ajax ersetzt das Portal den kompletten Formularinhalt
  // (document.TargetForm.innerHTML = response); das Menue steht dann wieder roh ueber
  // dem Inhalt. Der Callback laeuft als Microtask -- also noch vor dem naechsten Paint.
  // Deshalb hier synchron aufraeumen und NICHT verzoegern: sonst zeichnet der Browser
  // den Rohzustand einen Wimpernschlag lang mit.
  layoutObserver = new MutationObserver(() => {
    if (needsLayoutFix()) {
      runEnsureLayout();
      return;
    }
    updateSidebarVisibility();
  });
  layoutObserveTarget = document.body;
  if (layoutObserveTarget) {
    layoutObserver.observe(layoutObserveTarget, {
      childList: true,
      subtree: true
    });
  }
  const MESSAGE_TYPE = 'avlKundenportal:iframeResize';
  const REQUEST_TYPE = 'avlKundenportal:requestResize';
  window.avlKpIframeResizeDebug = window.avlKpIframeResizeDebug || {
    lastHeight: 0
  };
  const getTargetOrigin = () => {
    const {
      referrer
    } = document;
    if (!referrer) {
      return '*';
    }
    try {
      return new URL(referrer).origin;
    } catch (error) {
      return '*';
    }
  };
  const referrerOrigin = getTargetOrigin();
  const targetOrigin = '*';
  window.avlKpIframeResizeDebug.targetOrigin = targetOrigin;
  window.avlKpIframeResizeDebug.referrerOrigin = referrerOrigin;
  const getContentWrapperHeight = () => {
    const wrapper = document.getElementById('contentWrapper');
    if (!wrapper) {
      return 0;
    }
    const rect = wrapper.getBoundingClientRect();
    const top = rect.top + window.scrollY;
    const height = wrapper.scrollHeight;
    if (!Number.isFinite(top) || !Number.isFinite(height)) {
      return 0;
    }
    return Math.max(0, Math.round(top + height));
  };
  const getDocumentHeight = () => {
    const {
      body
    } = document;
    const html = document.documentElement;
    if (!body || !html) {
      return 0;
    }
    const wrapperHeight = getContentWrapperHeight();
    const bodyScrollHeight = body.scrollHeight;
    const htmlScrollHeight = html.scrollHeight;
    window.avlKpIframeResizeDebug.measurements = {
      wrapperHeight,
      bodyScrollHeight,
      htmlScrollHeight
    };
    if (wrapperHeight > 0) {
      return wrapperHeight;
    }
    return Math.max(bodyScrollHeight, htmlScrollHeight);
  };
  let lastHeight = 0;
  let rafId = null;
  const postHeight = () => {
    rafId = null;
    const height = getDocumentHeight();
    if (!height || height === lastHeight) {
      return;
    }
    lastHeight = height;
    window.avlKpIframeResizeDebug.lastHeight = height;
    const targetWindow = window.top && window.top !== window ? window.top : window.parent;
    if (!targetWindow || typeof targetWindow.postMessage !== 'function') {
      return;
    }
    targetWindow.postMessage({
      type: MESSAGE_TYPE,
      height,
      href: window.location.href
    }, targetOrigin);
  };
  const schedulePostHeight = () => {
    if (rafId) {
      return;
    }
    rafId = window.requestAnimationFrame(() => {
      postHeight();
      window.setTimeout(postHeight, 50);
      window.setTimeout(postHeight, 250);
    });
  };
  schedulePostHeightFn = schedulePostHeight;
  window.addEventListener('load', schedulePostHeight);
  window.addEventListener('resize', schedulePostHeight);
  if (document.fonts && typeof document.fonts.addEventListener === 'function') {
    document.fonts.addEventListener('loadingdone', schedulePostHeight);
  }
  if (typeof $ !== 'undefined' && typeof $.fn !== 'undefined') {
    // Direktester Weg: laeuft im selben Task wie der innerHTML-Ersatz, noch vor dem Paint.
    $(document).on('AjaxOnPart AjaxOnPage', () => {
      runEnsureLayout();
      schedulePostHeight();
    });
  }

  // Scroll to top when forward/submit buttons are clicked
  document.addEventListener('click', event => {
    const target = event.target.closest('a.action[data-ajax="NO"]');
    if (!target) return;
    const submitAction = target.getAttribute('data-submitaction');
    const buttonText = target.textContent.trim().toLowerCase();

    // Check if it's a forward/submit button (not back/cancel)
    if (submitAction === 'forward' || buttonText === 'weiter' || buttonText === 'absenden') {
      const targetWindow = window.top && window.top !== window ? window.top : window.parent;
      if (targetWindow && typeof targetWindow.postMessage === 'function') {
        targetWindow.postMessage({
          type: 'avlKundenportal:scrollToIframe'
        }, '*');
      }
    }
  }, true);
  const observeTarget = document.getElementById('contentWrapper') || document.body || document.documentElement;
  if (typeof ResizeObserver !== 'undefined' && observeTarget) {
    const resizeObserver = new ResizeObserver(schedulePostHeight);
    resizeObserver.observe(observeTarget);
  }
  if (typeof MutationObserver !== 'undefined' && observeTarget) {
    const mutationObserver = new MutationObserver(schedulePostHeight);
    mutationObserver.observe(observeTarget, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  window.addEventListener('message', event => {
    const {
      data
    } = event;
    if (!data || typeof data !== 'object') {
      return;
    }
    if (data.type === REQUEST_TYPE) {
      schedulePostHeight();
    }
  });
  schedulePostHeight();
})();